const updates = [
  {
    id: 1,
    date: '2026-08-01',
    title: '暑期档专题合集正式上线',
    desc: '涵盖动作、动画、科幻三大类型，精选30部暑期热门大片，一页尽览不迷路。',
  },
  {
    id: 2,
    date: '2026-07-29',
    title: '服务器全面升级，加载速度再提升40%',
    desc: '完成CDN节点扩容与视频编码优化，高清影片加载速度全面提升，4K片源秒开体验。',
  },
  {
    id: 3,
    date: '2026-07-25',
    title: '新增100+经典修复版影片',
    desc: '《霸王别姬》《花样年华》等影史经典高清修复版上线，致敬光影大师。',
  },
  {
    id: 4,
    date: '2026-07-20',
    title: '移动端观影体验全面优化',
    desc: '针对手机与平板设备进行专项适配，手势操作更流畅，移动观影更便捷。',
  },
  {
    id: 5,
    date: '2026-07-15',
    title: '悬疑片专题「迷雾剧场」上线',
    desc: '精选国内外高分悬疑佳作，从经典推理到现代心理惊悚，满足你的烧脑需求。',
  },
  {
    id: 6,
    date: '2026-07-10',
    title: '智能推荐系统升级',
    desc: '基于观影偏好与评分数据的智能推荐算法上线，精准发现你的下一部心头好。',
  },
  {
    id: 7,
    date: '2026-07-05',
    title: '极速影视正式上线运营',
    desc: '极速影视高清电影大全平台正式面向影迷开放，提供海量高清资源免费在线观看。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500">极速影视平台更新与运营动态一览</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item) => (
              <div key={item.id} className="mb-8 last:mb-0 relative">
                <div className="absolute -left-[33px] w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50 top-1"></div>
                <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-1 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}